import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch, apiSearch } from '../modules/utility';

const apiBase = 'ptoRequest';
const myRequestListName = 'myPtoRequests';
const myApprovalListName = 'myPtoApprovals';

const myRequestIdsField = 'myPtoRequestIds';
const myApprovalIdsField = 'myPtoApprovalIds';

//const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;
//const idsField = `${idField}s`;
const item = 'PTO request';
const onSuccessRedirectTo = `/pto/request/dashboard`;
const onUpdateSuccessRedirectTo = `/pto/approval/dashboard`;
const onUserUpdateSuccessRedirectTo = `/pto/request/dashboard`;

const search = (p = {}) => {
	const { params, callback = _.noop } = p;

	const { searchFor } = params;
	let listName = searchFor === 'myRequests' ? myRequestIdsField : myApprovalIdsField;

	return (dispatch) => {
		apiSearch({
			base: apiBase,
			forceEmptySet: true,
			listName,
			params,
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			idFieldForListUpdate: 'ptoRequestIds',
			listNameToUpdate: myRequestIdsField,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage: `PTO Request updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			delay: 350,
			callback,
		});
	};
};

const update = ({ params, isUserUpdate, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage: `PTO Request updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo: isUserUpdate ? onUserUpdateSuccessRedirectTo : onUpdateSuccessRedirectTo,
			delay: 350,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const newState = {};

	const userId = ownProps[idField]
		? ownProps[idField]
		: _.get(ownProps, ['match', 'params', idField]);

	newState[apiBase] = _.get(state.maps, [apiBase, userId]);

	newState[myRequestListName] = undefined;
	newState[myApprovalListName] = undefined;

	if (state.lists[myRequestIdsField]) {
		newState[myRequestListName] = _.map(
			state.lists[myRequestIdsField],
			(id) => state.maps[apiBase][id]
		);
	}
	if (state.lists[myApprovalIdsField]) {
		newState[myApprovalListName] = _.map(
			state.lists[myApprovalIdsField],
			(id) => state.maps[apiBase][id]
		);
	}

	newState.userMap = state.maps.user;
	return newState;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchPtoRequests: search,
			getPtoRequest: get,
			addPtoRequest: add,
			updatePtoRequest: update,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
